import { HttpErrorResponse } from '@angular/common/http';
import { EMAIL_ALREADY_REGISTERED } from '@features/auth/data-access/mappers/auth.mapper';

export type AuthRequestErrorKind =
  | 'credentials'
  | 'network'
  | 'unavailable'
  | 'generic'
  | 'email_already';

export type AuthErrorI18nScope =
  | 'auth.login'
  | 'auth.register'
  | 'auth.forgotPassword'
  | 'auth.resetPassword';

export function resolveAuthRequestErrorKind(error: unknown): AuthRequestErrorKind {
  if (error instanceof Error && error.message === EMAIL_ALREADY_REGISTERED) {
    return 'email_already';
  }
  if (error instanceof HttpErrorResponse) {
    if (error.status === 0) {
      return 'network';
    }
    if (error.status >= 500) {
      return 'unavailable';
    }
    if (error.status === 401 || error.status === 403 || error.status === 422) {
      return 'credentials';
    }
  }
  return 'generic';
}

export function authErrorI18nKey(scope: AuthErrorI18nScope, kind: AuthRequestErrorKind): string {
  if (kind === 'network') {
    return `${scope}.errorNetwork`;
  }
  if (kind === 'unavailable') {
    return `${scope}.errorUnavailable`;
  }
  if (scope === 'auth.forgotPassword') {
    return `${scope}.errorGeneric`;
  }
  if (scope === 'auth.resetPassword' && kind === 'credentials') {
    return `${scope}.errorInvalidToken`;
  }
  if (scope === 'auth.register' && kind === 'email_already') {
    return `${scope}.errorEmailAlready`;
  }
  if (scope === 'auth.register') {
    return `${scope}.errorFailed`;
  }
  if (kind === 'credentials') {
    return `${scope}.errorCredentials`;
  }
  return `${scope}.errorGeneric`;
}
